// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-G":"G_delta-pro-ultra-G__nJ1he"};